'use strict';

var firebase = require('firebase-legacy/app').default;
require('firebase-legacy/database');
var FirebaseExt = require('./FirebaseExt');
var KayleeAnalytics = require('./KayleeAnalytics');
var KayleeAuth = require('./KayleeAuth');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeCalls = require('./KayleeCalls');
var KayleeCompanies = require('./KayleeCompanies');
var KayleeCompany = require('./KayleeCompany');
var KayleeConnectionState = require('./KayleeConnectionState');
var KayleeController = require('./KayleeController');
var KayleeControllerAuth = require('./KayleeControllerAuth');
var KayleeEquipment = require('./KayleeEquipment');
var KayleeEquipmentStates = require('./KayleeEquipmentStates');
var KayleeEquipmentTypes = require('./KayleeEquipmentTypes');
var KayleeEvent = require('./KayleeEvent');
var KayleeEventFormatter = require('./KayleeEventFormatter');
var KayleeInaraInfo = require('./KayleeInaraInfo');
var KayleeKayleeInfo = require('./KayleeKayleeInfo');
var KayleeLog = require('./KayleeLog');
var KayleeMalInfo = require('./KayleeMalInfo');
var KayleeRemoteControlSessions = require('./KayleeRemoteControlSessions');
var KayleeRoles = require('./KayleeRoles');
var KayleeRoom = require('./KayleeRoom');
var KayleeRoomConfig = require('./KayleeRoomConfig');
var KayleeRoomConfigValidated = require('./KayleeRoomConfigValidated');
var KayleeRoomDiscoveredEquipment = require('./KayleeRoomDiscoveredEquipment');
var KayleeSerializer = require('./KayleeSerializer');
var KayleeSite = require('./KayleeSite');
var KayleeTosHtml = require('./KayleeTosHtml');
var KayleeTosInfo = require('./KayleeTosInfo');
var KayleeTutorials = require('./KayleeTutorials');
var KayleeUser = require('./KayleeUser');
var KayleeUserRemove = require('./KayleeUserRemove');
var KayleeVisualThemes = require('./KayleeVisualThemes');
var KayleeWhatsNew = require('./KayleeWhatsNew');
var RoomCopy = require('./RoomCopy');

var Kaylee = {
    addCompany: KayleeCompany.addCompany,
    addRemoteControlSession: KayleeRemoteControlSessions.addRemoteControlSession,
    addUpdatesToCreateController: KayleeController.addUpdatesToCreateController,
    callTypes: KayleeCalls.callTypes,
    copyRoom: RoomCopy.copyRoom,
    createUser: KayleeUser.createUser,
    factoryResetController: KayleeController.factoryResetController,
    getAlias: function() { return KayleeBase.alias; },
    getAnalyticsData: KayleeAnalytics.getAnalyticsData,
    getAuthDomain: KayleeBase.getAuthDomain,
    getCallClass: KayleeCalls.getCallClass,
    getCompanies: KayleeCompanies.getCompanies,
    getCompany: KayleeCompany.getCompany,
    getController: KayleeController.getController,
    getControllerBySerialNumber: KayleeController.getControllerBySerialNumber,
    getDriverId: KayleeEquipment.getDriverId,
    getEquipment: KayleeEquipment.getEquipment,
    getEquipmentStates: KayleeEquipmentStates.getEquipmentStates,
    getEqTypeProp: KayleeEquipment.getEqTypeProp,
    getEqTypeConfigProp: KayleeEquipment.getEqTypeConfigProp,
    getEquipmentTypes: KayleeEquipmentTypes.getEquipmentTypes,
    getEventActor: KayleeEventFormatter.getActor,
    getEventDescription: KayleeEventFormatter.getDescription,
    getFirebaseConsoleUrl: KayleeBase.getFirebaseConsoleUrl,
    getInaraInfo: KayleeInaraInfo.get,
    getKayleeInfo: KayleeKayleeInfo.get,
    getLog: KayleeLog.getLog,
    getMalInfo: KayleeMalInfo.get,
    getNewKey: KayleeBase.getNewKey,
    getProjectId: KayleeBase.getProjectId,
    getRelevantRoles: KayleeRoles.getRelevantRoles,
    getRemoteAuthUrl: KayleeBase.getRemoteAuthUrl,
    getRoom: KayleeRoom.getRoom,
    getRoomConfig: KayleeRoomConfig.getRoomConfig,
    getRoomConfigValidated: KayleeRoomConfigValidated.getRoomConfigValidated,
    getRoomDiscoveredEquipment: KayleeRoomDiscoveredEquipment.getRoomDiscoveredEquipment,
    getSite: KayleeSite.getSite,
    getTosInfo: KayleeTosInfo.get,
    getTosHtml: KayleeTosHtml.getTosHtml,
    getTutorials: KayleeTutorials.getTutorials,
    getUser: KayleeUser.getUser,
    getUserByEmail: KayleeUser.getUserByEmail,
    getVisualThemes: KayleeVisualThemes.getVisualThemes,
    getWhatsNew: KayleeWhatsNew.getWhatsNew,
    initialize: KayleeBase.initialize,
    isAuthenticated: KayleeAuth.isAuthenticated,
    isAuthenticatedAsAnonymous: KayleeAuth.isAuthenticatedAsAnonymous,
    isAuthenticatedAsAnonymousRemoteControl: KayleeAuth.isAuthenticatedAsAnonymousRemoteControl,
    isAuthenticatedAsController: KayleeAuth.isAuthenticatedAsController,
    isAuthenticatedAsUser: KayleeAuth.isAuthenticatedAsUser,
    isConnected: KayleeConnectionState.isConnected,
    isRole: KayleeRoles.isRole,
    isWorkingOnline: KayleeConnectionState.isWorkingOnline,
    onAuthStateChanged: KayleeBase.onAuthStateChanged,
    onConnectionStateChanged: KayleeConnectionState.onConnectionStateChanged,
    offConnectionStateChanged: KayleeConnectionState.offConnectionStateChanged,
    onWorkingOnlineChanged: KayleeConnectionState.onWorkingOnlineChanged,
    offWorkingOnlineChanged: KayleeConnectionState.offWorkingOnlineChanged,
    onUpdate: FirebaseExt.onUpdate,
    offUpdate: FirebaseExt.offUpdate,
    pairUsingCode: KayleeController.pairUsingCode,
    removeEvent: KayleeEvent.removeEvent,
    removeEvents: KayleeEvent.removeEvents,
    removeRemoteControlSession: KayleeRemoteControlSessions.removeRemoteControlSession,
    removeUser: KayleeUserRemove.removeUser,
    removeUserByEmail: KayleeUserRemove.removeUserByEmail,
    resetPassword: KayleeAuth.resetPassword,
    requestRemoteAuth: KayleeAuth.requestRemoteAuth,
    requestPairingCode: KayleeController.requestPairingCode,
    getCache: function() {
        var cache = KayleeCache.getCache();
        return KayleeSerializer.toJson(cache);
    },
    serverValueTimestamp: function() { return firebase.database.ServerValue.TIMESTAMP; },
    setConnected: KayleeConnectionState.setConnected,
    setOfflineTimeoutMs: KayleeConnectionState.setOfflineTimeoutMs,
    setRoleByEmail: KayleeRoles.setRoleByEmail,
    setUpdateTimeMs: FirebaseExt.setUpdateTimeMs,
    setWorkingOnline: function(online, cache) {
        if (online === KayleeConnectionState.isWorkingOnline()) return;

        KayleeCache.clear();
        if (!online) KayleeSerializer.fromJson(cache);
        KayleeConnectionState.setWorkingOnline(online);
    },
    signInAsController: KayleeControllerAuth.signIn,
    signInWithCustomToken: KayleeAuth.signInWithCustomToken,
    signInWithEmailAndPassword: KayleeAuth.signInWithEmailAndPassword,
    signOut: KayleeAuth.signOut,
};

module.exports = Kaylee;
